import AIJob from 'models/AIJob';
import JobProcess from 'models/JobProcess';
import { BaseMutationParams } from 'services/api/types';
import http from 'services/http';

export const aiJobQueryKeys = {
  base: ['aiJobs'],
  show: (id: string) => ['aiJobs', 'show', id],
};

type CreateAIJobInput = {
  type: string;
  reviewId?: string;
  aiCriteriaSetId?: string;
} & BaseMutationParams;

export const createAIJob = async (input: CreateAIJobInput) => {
  const { include, ...data } = input;
  return http.post<any>('/ai_jobs', data, { params: { include } }).then(
    (response) =>
      new AIJob({
        ...response.data,
        reviewId: response.data.reviewId || undefined,
      })
  );
};

export async function createAIJobExport(id: string) {
  return http.post<JobProcess>(`/ai_jobs/${id}/exports`).then((res) => new JobProcess(res.data));
}
